import { ComponentBehavior } from "@mcleod/components";

export class AppComponentBehavior extends ComponentBehavior {
    protected constructor() {
        super();
    }

    public fillWindowHeight(topAdjust: number = 0): string {
        return "calc(100% - " + (topAdjust) + "px)";
    }
}

AppComponentBehavior.register();
